import { render, staticRenderFns } from "./SingConfig.vue?vue&type=template&id=dd394b94&scoped=true&"
import script from "./SingConfig.vue?vue&type=script&lang=js&"
export * from "./SingConfig.vue?vue&type=script&lang=js&"
import style0 from "./SingConfig.vue?vue&type=style&index=0&id=dd394b94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd394b94",
  null
  
)

export default component.exports